import ScrollReveal from "../../../components/feature/ScrollReveal";
import { validityData } from "../../../mocks/giftData";

export default function ValiditySection() {
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-14">
              <p className="section-label mb-2">{validityData.label}</p>
              <h2 className="section-title">{validityData.title}</h2>
              <p className="section-subtitle max-w-2xl mx-auto">
                {validityData.description}
              </p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-8 md:mb-10">
            {validityData.points.map((p, idx) => (
              <ScrollReveal key={p.title} direction="up" delay={idx * 100}>
                <div className="bg-white rounded-lg p-6 md:p-8 h-full text-center border border-airdoa-gray-light/30">
                  <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold mb-4">
                    <i className={`${p.icon} text-xl`} />
                  </div>
                  <h3 className="text-base font-serif font-semibold text-airdoa-navy mb-2">
                    {p.title}
                  </h3>
                  <p className="text-sm text-airdoa-gray leading-relaxed">
                    {p.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>

          <ScrollReveal direction="up" delay={200}>
            <div className="bg-airdoa-navy/5 rounded-lg p-5 md:p-6 flex items-start gap-3 border border-airdoa-navy/10">
              <span className="w-5 h-5 flex items-center justify-center text-airdoa-gold mt-0.5 shrink-0">
                <i className="ri-alert-line" />
              </span>
              <p className="text-sm text-airdoa-gray leading-relaxed">
                {validityData.caution}
              </p>
            </div>
          </ScrollReveal>
        </div>
      </div>
    </section>
  );
}